import React from 'react';

const SvgBatteryOk = (props) => (
  <svg id="batteryOk" viewBox="0 0 10 10" width="1em" height="1em" {...props}>
    <path
      d="M9.08 3.49h.82v2.74h-.82zM1.69 3.29l2.08 2.07L6.58 2.5H.65a.57.57 0 00-.57.57V4.9l1.61-1.61zM.08 5.08v1.58c0 .32.26.57.57.57h1.6L.08 5.08z"
      fill="currentColor"
    />
    <path
      d="M8.51 2.5l.55.54-4.15 4.19h3.6c.32 0 .57-.26.57-.57V3.07c0-.31-.26-.57-.57-.57z"
      fill="currentColor"
    />
    <path
      d="M3.6 7.92L.65 4.97l.98-.99L3.65 6l3.92-3.92.94.93z"
      fill="currentColor"
    />
  </svg>
);

export default SvgBatteryOk;
